// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-6086b0fc] .ant-input-number-group-wrapper:nth-child(-n + 2) .ant-input-number-group-addon {\n  border-right: none !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
